import { Attribute, Relationship, Resource } from 'json-api';
import { AtomResource } from '../classes/atom-resource';
import { ResourceConfig } from 'src/app/resources/resources-interfaces/resource-config';
import { AtomService } from '../atom.service';
import { LegalDocument } from './legal-document.resource';
import {
  LegalDocumentVersionArchive,
  LegalDocumentVersionArchiveConfig,
} from './legal-document-version-archives.resource';
import {LegalDocumentConfig } from '../../shared/tools/search/search-config';
import { Enum } from './enum.resource';
import { DateFilter, ListFilter, NumberFilter, ValidityFilter } from '../../filter/filter';

@Resource({
  type: 'legaldocumentversions',
})
export class LegalDocumentVersion extends AtomResource {
  @Attribute() state?: Enum;
  @Attribute({ key: 'publish_at' }) publishAt?: Date ;
  @Attribute() validity?: string;
  @Attribute() content?: string;

  @Relationship() legaldocument?: LegalDocument;
  @Relationship() archives?: LegalDocumentVersionArchive[];
}
export class LegalDocumentVersionConfig implements ResourceConfig {
  workflow = {
    mainflow: [
      {label: "draft"},
      {label: "validated"},
      {label: "published", datas: [
        {
          type: 'date',
          formControl: 'publishAt',
        }
      ]}
    ],
    commonTransitions: [
      {label: 'cancel', icon: 'cancel'},
      {label: 'restart', icon: 'refresh'}
    ],
    finalStates: ['cancelled']
  };
  defaultSort='-id';
  tables = {
    includes: ['legaldocument'],
    columns: [
      {
        columnDef: 'id',
        displayedDatas: [{ path: ['id'], class: 'main' }],
        header: 'ID',
        translatable: false,
        displayed: true,
        sort: '-id',
      },
      {
        columnDef: 'state / publishAt',
        displayedDatas: [{ path: ['state'], class: 'mat-body-2'},{ path: ['publishAt'], class: 'mat-body-2',type: 'date'}],
        header: 'Publish At',
        displayed: true,
        link: {
          detail: true,
        },
        sort: 'publish_at',
      },
      {
        columnDef: 'status',
        header: '',
        // displayedDatas: [{ path: ['validity'], class: 'mat-body-2',}],
        displayed: true,
        sort: 'validity',
      },
      {
        columnDef: 'legaldocument',
        displayedDatas: [
          { path: ['legaldocument.name'], class: 'mat-body-2'},
          { path: ['legaldocument.documentType'], class: 'mat-body-1'}
        ],
        header: 'Document / Type',
        displayed: true,
        link: {
          resource: 'legaldocuments',
          filter: 'legaldocument.id',
          target: 'legaldocumentversions',
          icon: 'local_police',
        },
        sort: 'legaldocument.name',
      },
      {
        columnDef: 'legaldocumentversionarchives',
        displayed: true,
        link: {
          resource: 'legaldocumentversionarchives',
          list: 'legaldocumentversionarchives',
          target: 'legaldocumentversion',
        },
        header: 'Document Archives',
      },
      {
        columnDef: 'actions',
        header: 'Actions',
        displayed: true,
      },
    ],
  };
  detail = {
    header: {
      icon: 'policy',
      title: [],
      id: true,
    },
    elements: [
      {
        columns: true,
        showEmpty: true,
        list: [
          {
            icon: 'timer',
            title: 'Publish Date',
            APIKey: 'publishAt',
            value: {
              path: ['publishAt'],
              type: 'date'
            },
          },
          {
            icon: 'manage_history',
            title: 'Product Use Only Last version',
            APIKey: 'use_only_last_version',
            value: {
              path: ['legaldocument.useOnlyLastVersion'],
            },
          },
          {
            icon: 'local_police',
            title: 'Document Name',
            APIKey: 'legaldocument.name',
            value: {
              path: ['legaldocument.name'],
            },
          },
          {
            icon: 'category',
            title: 'Document Type',
            APIKey: 'legaldocument.documentType',
            value: {
              path: ['legaldocument.documentType'],
            },
          }
        ]
      }
  ],
    tabs: [
      {
        title: 'Document Content',
        elements: [
          {
            showEmpty: true,
            list: [
              {
                type: 'textarea',
                icon: 'description',
                title: 'Content',
                APIKey: 'content',
                value: {
                  path: ['content'],
                },
              }
            ]
          }
          ]
      },
      {
        title: 'Document Archives',
        elements: [
          {
            resource: {
              APIKey: 'archives',
              config: new LegalDocumentVersionArchiveConfig(this.atom),
              multiple: true,
            },
          }
        ]
      },

    ]
  }
  wizard = {
    tabs: [
      {
        title: 'General Informations',
        formGroup: 'general',
        list: [
          {
            type: 'resource',
            title: 'Legal Document',
            formControl: 'legaldocument',
            APIKey: 'legaldocument',
            search: new LegalDocumentConfig(this.atom),
            required: true,
            noCols: true,
          },
          {
            type: 'textarea',
            title: 'Content',
            formControl: 'content',
            APIKey: 'content',
            required: true,
            noCols: true,
          },
        ]
      }
    ]
  }

  resource = LegalDocumentVersion;
  resourceName = 'Legal Document Version';
  resourceKey = 'legaldocumentversions';
  resourceKeySingle = 'legaldocumentversion';
  includes = [
    'legaldocument'
  ];
  filters = [
    new NumberFilter('id', 'ID'),
    new DateFilter('publish_at', 'Publish Date', true),
    new ListFilter([
      { value: 'draft', label: 'draft' },
      { value: 'validated', label: 'validated' },
      { value: 'published', label: 'published' },
      { value: 'cancelled', label: 'cancelled' },
    ],'state'),
    new ValidityFilter('validity', 'Validity', true),

  ];
  constructor(private atom: AtomService, public hosted: string = 'legaldocument') {}
}
